module.exports = __webpack_public_path__ + "static/media/05.fac4f4b8.png";